/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/suppression_rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postEngagementAppGroupIdSuppressionRulesCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdSuppressionRulesProps,
  PostEngagementAppGroupIdSuppressionRulesResult,
} from "./types";

/**
 * POST handler for the "/engagement/:app_group_id/suppression_rules" endpoint
 */
export const postEngagementAppGroupIdSuppressionRules = reactQueryMutationAdapter(
  postEngagementAppGroupIdSuppressionRulesCacheKeys,
  (
    props: PostEngagementAppGroupIdSuppressionRulesProps
  ): Promise<PostEngagementAppGroupIdSuppressionRulesResult> => {
    const body: Record<string, unknown> = {
      type: props.type,
      name: props.name,
    };

    if (props.enabled !== undefined) {
      body.enabled = props.enabled;
    }

    if (props.sendingDomain !== undefined) {
      body.sending_domain = props.sendingDomain;
    }

    if (props.bounceClassifications !== undefined) {
      body.bounce_classifications = props.bounceClassifications;
    }

    if (props.softBounceCount !== undefined) {
      body.soft_bounce_count = props.softBounceCount;
    }

    if (props.minDaysApart !== undefined) {
      body.min_days_apart = props.minDaysApart;
    }

    return fetch(`/engagement/${props.appGroupId}/suppression_rules`, "POST", body, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
